import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { BookOpen, ArrowLeft, Clock } from "lucide-react";
import api, { getBoardroomToken, clearBoardroomToken } from "../utils/qccaApi";

export default function QCCAMinuteBook() {
  const nav = useNavigate();
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getBoardroomToken()) { nav("/qcca/boardroom/login"); return; }
    api.get("/qcca/minute-book/documents")
      .then((r) => setDocs(r.data.documents || []))
      .catch((e) => {
        if (e?.response?.status === 401) { clearBoardroomToken(); nav("/qcca/boardroom/login"); }
        else toast.error("Failed to load Minute Book.");
      })
      .finally(() => setLoading(false));
  }, [nav]);

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Link to="/qcca/boardroom" className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-gray-400 hover:text-[#C5A52A] mb-6">
          <ArrowLeft className="w-3 h-3" /> Boardroom
        </Link>

        <div className="mb-10">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#C5A52A]">Digital Minute Book</div>
          <h1 className="mt-3 font-headline text-4xl text-white leading-tight">Your <span className="italic text-[#C5A52A]">record.</span></h1>
          <p className="mt-3 text-gray-400 leading-relaxed max-w-2xl">
            Every meeting filed away. Documents come from the Digital Clerk or can be written directly. Share any page with the board in one click.
          </p>
        </div>

        {loading ? (
          <div className="text-gray-500 font-mono text-sm">Loading…</div>
        ) : docs.length === 0 ? (
          <div className="border border-dashed border-[#1a1a1a] bg-[#0a0a0a] p-12 text-center">
            <BookOpen className="w-10 h-10 text-[#C5A52A] mx-auto" />
            <h3 className="mt-4 font-headline text-2xl text-white">Empty so far.</h3>
            <p className="mt-2 text-gray-400 text-sm max-w-md mx-auto">
              Record your next meeting with the Digital Clerk — minutes land here automatically.
            </p>
            <Link to="/qcca/boardroom/clerk/new" className="inline-flex items-center gap-2 mt-6 bg-[#C5A52A] hover:bg-[#D4B93A] text-black font-mono text-xs uppercase tracking-[0.22em] px-5 py-3 transition-colors">
              Start a meeting →
            </Link>
          </div>
        ) : (
          <div className="grid gap-4" data-testid="qcca-minutebook-list">
            {docs.map((d) => (
              <Link key={d.id} to={`/qcca/boardroom/minutebook/${d.id}`}
                className="block group bg-[#0a0a0a] border border-[#1a1a1a] hover:border-[#C5A52A]/60 p-6 transition-colors"
                data-testid={`qcca-minutebook-row-${d.id}`}>
                <div className="flex items-start justify-between gap-4 flex-wrap">
                  <div className="min-w-0 flex-1">
                    <h3 className="font-headline text-xl text-white leading-tight group-hover:text-[#C5A52A] transition-colors">{d.title}</h3>
                    <div className="mt-1 font-mono text-[11px] text-gray-500">
                      {d.meeting_date || new Date(d.created_at).toLocaleDateString()} · {d.corporation}
                    </div>
                  </div>
                  <div className="font-mono text-[10px] text-gray-500 flex items-center gap-2">
                    <Clock className="w-3 h-3 text-[#C5A52A]" />
                    {new Date(d.created_at).toLocaleString()}
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
